import { Component, OnInit,Output,
  EventEmitter, } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { Router } from "@angular/router";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "src/app/Shared/app.Masters.Service";
import { constantUrl } from "src/app/Shared/constantUrl";
import { DialogService } from "src/app/Shared/dialog.service";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
// import { QuickLoanService } from "../services/quickLoan.service";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { LosService } from "src/app/_LOS/services/los.service";
import { LmsService } from "../../_Lms/services/lms.service";
import { MatTableDataSource } from "@angular/material/table";
import { QuickLoanService } from "src/app/_QuickLoan/services/quickLoan.service";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';


declare var UnaportFIU: any;
  declare var $: any;


@Component({
  selector: 'app-fiu-unaport-sdk',
  templateUrl: './fiu-unaport-sdk.component.html',
  styleUrls: ['./fiu-unaport-sdk.component.scss']
})
export class FiuUnaportSdkComponent implements OnInit {
  showSpinner: boolean = false;
  currentUser: any;
  currentUrl = window.location.origin + window.location.pathname;

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  customerPhone: any;
  safeSdkUrl!: SafeResourceUrl;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _Route: Router,
    private dialog: DialogService,
    private dataSharingService: DataSharingService,

    private snackBar: MatSnackBar,
    private _MasterService: MasterService,
    private losService: LosService,
    private LmsService: LmsService,
    private _EncrDecrService: EncrDecrService,
    private _QuickLoanService: QuickLoanService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.customerPhone="9653736485";
  //   window.addEventListener("message", (event: any) => {

  //   console.log("SDK Message:", event.data);

  //   if (event.data?.type === "SDK_CLOSE") {
  //     console.log("SDK Closed");

  //     // Close modal or iframe
  //     this.closeModal();
  //   }

  //   if (event.data?.type === "CONSENT_SUCCESS") {
  //     console.log("Consent Success:", event.data);

  //     this.action.emit(event.data);
  //   }

  // });
  // this.route.queryParams.subscribe(params => {
  //   if (params && params['status']) {
  //     console.log("SDK Response:", params);

  //     if (params['status'] === 'SUCCESS') {
  //       // ✅ Use consentId
  //       const consentId = params['consentId'];
  //     }
  //   }
  // });
  }

  // getTokenAndLaunchSDK() {
  //   console.log("tetsing: reached sdk component.")

  //   this._MasterService.GetAccessTokenAPI().subscribe((res: any) => {

  //     if (!res?.accessToken) {
  //       console.error("Token failed");
  //       return;
  //     }
  //     console.log(res);

  //     this.launchFIUHostedSDK(res);
  //   });
  // }

// loadFIUSdk(): Promise<void> {
//   return new Promise((resolve, reject) => {

//     if ((window as any).UnaportFIU) {
//       resolve();
//       return;
//     }

//     const script = document.createElement('script');
//     script.src = "https://sdk.sandbox.unaport.com/view";

//     script.onload = () => resolve();
//     script.onerror = () => reject("Failed to load FIU SDK");

//     document.body.appendChild(script);
//   });
// }

// launchFIUHostedSDK(tokenData: any) {

//   try {

//   const config = {
//     theme: {
//     "background": "#131313",
//     "accent": "#1B1B1B",
//     "primary": "#7762FF",
//     "primaryText": "#FFFFFF",
//     "primaryButtonText": "131313",
//     "secondary": "#C589E4",
//     "secondaryText": "#F2F2F2",
//     "disabled": "#1F1F1F",
//     "disabledText": "#FEFEFE",
//     "border": "#767676",
//     "hintText": "#9e9e9e",
//     "errorText": "#d32f2f",
//     "loaderColor": "#F2F2F2",
//     "fontName": "Open Sans"
//   },
//     productId: "07f25803-762d-4e9a-ab3b-b1cb5f2f2f36",
//     phoneNumber: this.customerPhone,
//     trackingId: Date.now().toString(),
//     fiuId: "UNACORES-FIU-UAT",
//     FIType: "Deposits",
//     accessToken: tokenData.accessToken,
//     refreshToken: tokenData.refreshToken,
//     redirectUrl: this.currentUrl
//   };

//   const base64Config = btoa(
//     unescape(encodeURIComponent(JSON.stringify(config)))
//   );

//   const url = `https://sdk.sandbox.unaport.com/view?config=${base64Config}`;
//   this.safeSdkUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

//   console.log("Final URL:", url);
//   console.log("sanititzzed",this.safeSdkUrl)

//     // const iframe = document.getElementById('fiuSdkFrame') as HTMLIFrameElement;
//     // iframe.src = url;

//    // window.location.href = url;
//        window.open(url, "_blank");
//     // $("#fiusdk").modal("show");
//     // $("#fiusdk").css("z-index", "1050");
    

//     } catch (error) {

//       console.error("Digio SDK error", error);

//       this.snackBar.openFromComponent(SnackbarComponent, {
//         data: "Unable to launch Digio SDK",
//         ...this.configSuccess,
//       });

//     }
// }

// closeModal(){

//   $(`#fiusdk`).modal("hide");
// }

}
